import React from "react";
import { StaffAttendanceStatisticsFragment } from "@sinch/components/application/StaffDetailPanel/queries.types";
import { useFormat } from "@sinch/core/hooks/format";
import { useTranslation } from "react-i18next";
import { rejectFalsy } from "@sinch/utils/array";
import { MdsAlarmXs, MdsAssignmentTurnedInXs, MdsTimelapseXs, SinchAbsentXs, SinchAmbulanceXs } from "@sinch/icons";
import { Stack } from "@mui/material";
import { IconStat } from "@sinch/components/IconStat/IconStat";

export const StaffStats: React.FC<{ statistics: StaffAttendanceStatisticsFragment }> = ({ statistics }) => {
  const { num } = useFormat();
  const { t } = useTranslation();

  const presentRatio = statistics.presentCount / statistics.totalCount;
  const stats = rejectFalsy([
    {
      icon: MdsTimelapseXs,
      value: statistics.totalCount,
      title: t("ShiftTimeline.shiftsInTotal"),
    },
    {
      icon: MdsAssignmentTurnedInXs,
      value: Number.isNaN(presentRatio) ? "N/A" : num.percent(presentRatio),
      title: t("ShiftTimeline.noProblem"),
    },
    {
      icon: MdsAlarmXs,
      value: statistics.lateCount,
      title: t("ClosingForm.presenceLate"),
    },
    {
      icon: SinchAmbulanceXs,
      value: statistics.excusedCount,
      title: t("ClosingForm.presenceExcused"),
    },
    {
      icon: SinchAbsentXs,
      value: statistics.missCount,
      title: t("ShiftTimeline.notPresent"),
    },
  ]);

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        flexWrap: "nowrap",
      }}
    >
      {stats.map((stat) => (
        <IconStat key={stat.title} icon={stat.icon} title={stat.title} value={stat.value} />
      ))}
    </Stack>
  );
};
